module.exports = __webpack_public_path__ + "static/media/4.f8796494.svg";